angular.module('iconoglobe')
.service('strategicSearch', ['$http', "$q", function($http, $q){
  this.getResults = function(params){
    var deferred = $q.defer();
    $http.post('/data/keysearch', params).then(function (res) {
      deferred.resolve(res.data);
    }, function(err){
      deferred.reject('error occured');
    });
    return deferred.promise;
  }
}])